import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
	PaymentMethodApi,
	PaymentMethodIntegration,
	PaymentMethodSettingApi,
	PaymentMethodTPayPaymentsApi,
} from "../../../../../../../../../../services/Api/Organization/types";
import PaymentMethodIntegrationsItemForm from "./PaymentMethodIntegrationsItemForm";

interface Props {
	form: UseFormReturn<PaymentMethodApi>;
	tPayPayments?: PaymentMethodTPayPaymentsApi;
	setTPayPayments: React.Dispatch<React.SetStateAction<PaymentMethodTPayPaymentsApi | undefined>>;
	defaultSettings: PaymentMethodSettingApi[];
	fetchPaymentMethod?: () => Promise<void>;
}

const PaymentMethodOnlineIntegrationsForm = ({
	form,
	tPayPayments,
	setTPayPayments,
	defaultSettings,
	fetchPaymentMethod,
}: Props) => {
	const { t } = useTranslation();
	const { watch } = form;

	return (
		<fieldset className="form-group no-gutters">
			<h5>{t("modules.payment_method.field.online_payments.title")}</h5>
			<div className="d-flex flex-column">
				<PaymentMethodIntegrationsItemForm
					integration={PaymentMethodIntegration.TPAY}
					settings={watch("settings") || []}
					form={form}
					tPayPayments={tPayPayments}
					setTPayPayments={setTPayPayments}
					defaultSettings={defaultSettings}
					fetchPaymentMethod={fetchPaymentMethod}
				/>
			</div>
		</fieldset>
	);
};

export default PaymentMethodOnlineIntegrationsForm;
